(function () {
    const curator = document.querySelector(".curator-feed-visit-kapiti-layout")
    if (curator) {
        curator.setAttribute("id", "curator-feed-visit-kapiti-layout");
        const src = curator.dataset.src
        if (src) {
            const script = document.createElement("script")
            script.async = 1
            script.src = src
            const scriptEls = document.getElementsByTagName("script");
            if (scriptEls.length > 0) {
                firstScriptEl = scriptEls[0]
                firstScriptEl.parentNode.insertBefore(script, firstScriptEl)
            }
        }
    }
})()